import { useState } from "react";
import { faqs } from "@/mocks/content";
import SectionHeading from "./SectionHeading";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-16 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              index="09"
              eyebrow="FAQ"
              title="常见问题"
              desc="关于内容来源、可信度分级、投稿方式与更新节奏的说明，都在这里。"
            />
          </div>
          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={f.q} className="bg-background-100">
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-200/60"
                    >
                      <h3 className="font-heading text-sm font-bold text-foreground-950 md:text-base">{f.q}</h3>
                      <span
                        className={`grid h-7 w-7 shrink-0 place-items-center rounded-md transition-colors ${
                          isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                        }`}
                      >
                        <i className={`ri-add-line text-lg transition-transform ${isOpen ? "rotate-45" : ""}`} />
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5">
                        <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}